import { FaSeedling, FaTools, FaPaintRoller, FaRecycle } from 'react-icons/fa';

const features = [
    { 
        id: 1,
        icon: <FaSeedling />, // Seedling icon for Plant Diversity
        title: 'Plant Diversity',
        description: 'Offering a diverse selection of plants including flowers, shrubs, and trees',
    },
    {
        id: 2,
        icon: <FaTools />, // Tools icon for Design Consultation
        title: 'Design Consultation',
        description: 'Providing expert advice on plant selection, landscape design, and layout',
    },
    {
        id: 3,
        icon: <FaPaintRoller />, // Paint roller icon for Custom Landscaping
        title: 'Custom Landscaping',
        description: 'Creating tailor-made landscape designs to meet your functional needs',
    },
    {
        id: 4,
        icon: <FaRecycle />, // Recycling icon for Sustainable Practices
        title: 'Sustainable Practices',
        description: 'Promoting eco-friendly landscaping practices for a healthier environment',
    },
];

export default features;